<template>
  <div
    v-if="false"
    class="aggregator-select"
    :class="{ disabled: !isBasketCreated()}"
  >
    <template v-for="(aggregator, key) in aggregators">
      <div
        :key="key"
        class="aggregator-item"
        :class="{ active: isActiveSource(key)}"
        @click="selectAggregator(key)"
        :style="{'background-image': 'url('+aggregator.img+')'}"
        :title="aggregator.name"
      >
      </div>
    </template>
    <v-dialog
      v-model="error"
      max-width="550"
    >
      <v-card class="large-dialog">
        <v-card-title>
          <v-icon color="error">
            mdi-alert
          </v-icon>
          Ошибка выбора агрегатора
          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="error = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          {{ errorText }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'AggregatorSelect',
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        error: false,
        errorText: '',
        defaultSource: 'crm',
        aggregators: [
          {
            name: 'Яндекс.Еда',
            img: '/img/yandex_eda_logo.svg',
            source: 'yandex',
            active: false,
          },
          /* {
            name: 'Delivery Club',
            img: '/img/delivery_club_logo.jpg',
            source: 'deliveryСlub',
            active: false,
          }, */
        ],
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      currentSource: function () {
        return this.basket.basketSource || this.defaultSource
      },
    },
    methods: {
      isBasketCreated () {
        return !!this.basket.id
      },
      isActiveSource (key) {
        return this.currentSource === this.aggregators[key].source
      },
      showError (errorText) {
        this.errorText = errorText
        this.error = true
      },
      selectAggregator (key) {
        if (!this.isBasketCreated()) {
          this.showError('Корзина еще не создана. Сначала создайте клиента...')
          return
        }
        if (!this.isActiveSource(key)) {
          this.saveBasketSource(this.aggregators[key].source)
        } else {
          this.saveBasketSource(this.defaultSource)
        }
      },
      saveBasketSource (source) {
        this.basket.basketSource = source
        const data = {
          basketSource: source,
        }
        const id = this.basket.id
        this.$store
          .dispatch('baskets/updateBasket', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .aggregator-select {
    font-size: 25px;
    color: white;
    display: flex;

  .media-xl({
    font-size: 30px;
  });

    &.disabled {
      opacity: 0.5;
    }

    .aggregator-item {
      width: 1em;
      height: 1em;
      margin: 5px;
      border-radius: 5px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      cursor: pointer;
      &.active {
        box-shadow: 0 0 1px 3px #fff3d6;
      }
    }
  }

  .v-card.large-dialog {
    .v-icon {
      margin-right: 20px;
    }
    & > .v-card__title {
      font-size: 25px;

    }
    & > .v-card__text {
      font-size: 16px;
    }
  }
</style>
